import { jsx as _jsx } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import pingLogo from './ping-logo.png';
export default function PingCard() {
    const { t: texts } = useLocaleKeys('integrations.availableApps.ping');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('ping');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "ping-card",
        icon: /*#__PURE__*/ _jsx(IntegrationCard.LogoImg, {
            alt: "ping logo",
            src: pingLogo
        }),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_ping'
            },
            onClick: showCopyAPIKeyModal,
            testId: "ping-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
